module.exports = __webpack_public_path__ + "static/media/bd867a90.jpg";